import React, { MouseEvent } from 'react';
import { SHARE } from './SharePost.helper';

import Facebook from '@assets/svg/facebook-share.svg';
import LinkedIn from '@assets/svg/linkedIn-share.svg';

import s from './SharePost.module.scss';
import {useIntl} from 'gatsby-plugin-intl';

export const SharePost = () => {
  const intl = useIntl();

  const share = (e: MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();
    window.open(url, '_blank');
  };

  return (
    <div className={s.sharePost}>
      <div className={s.sharePost__content}>
        <span className={s.sharePost__text}>{intl.formatMessage({id: 'post__shareThis'})}</span>
        <a href={'#'} rel={'nofollow'} hrefLang={intl.locale} onClick={(e) => share(e, SHARE.getLinkedInURL())} className={s.sharePost__social}>
          <LinkedIn className={s.sharePost__socialSvg}/>
        </a>
        <a href={'#'} rel={'nofollow'} hrefLang={intl.locale} className={s.sharePost__social} onClick={(e) => share(e, SHARE.getFacebookURL())}>
          <Facebook className={s.sharePost__socialSvg}/>
        </a>
      </div>
    </div>
  );
};
